/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { redirect, type LoaderFunctionArgs } from 'react-router-dom';

import { getDefaultTeamId } from '@fai/friendli-suite/features/routes/loaders/apis/client-team';
import Paths from '@fai/friendli-suite/features/routes/paths';
import { customJson } from '@fai/third-party/react-router-dom';

export const redirectDefaultTeamToTeamIdPath = async ({
  request,
}: {
  request: LoaderFunctionArgs['request'];
}) => {
  const defaultTeamId = await getDefaultTeamId();

  if (!defaultTeamId) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw customJson({ message: "failed to load user's default team id" }, { status: 403 });
  }

  // cannot use `window.location.pathname` since `useNavigate.navigate` uses history.pushState, which does not call a http request(`window.location.pathname` is not updated)
  const currentPath = request.url;
  const defaultTeamPath = `${window.location.origin}${Paths.defaultTeam.default}`;

  if (!currentPath.startsWith(defaultTeamPath)) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw customJson(
      { message: "url doesn't match, cannot redirect to default team" },
      { status: 400 }
    );
  }

  const directoryExceptDefaultTeamPath = currentPath.slice(defaultTeamPath.length);

  return redirect(`${Paths.team(defaultTeamId).default}${directoryExceptDefaultTeamPath}`);
};
